import React, { useCallback } from "react";
import { WhatsAppOutlined } from "@ant-design/icons";

const FloatingWhatsApp = () => {
  const isMobile = window.innerWidth <= 640;

  const handleWhatsAppClick = useCallback(() => {
    window.open("https://wa.me/918248162712", "_blank");
  }, []);

  return (
    <>
      <div
        onClick={handleWhatsAppClick}
        onMouseOver={(e) => {
          e.target.style.transform = "scale(1.1)";
          e.target.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.3)";
        }}
        onMouseOut={(e) => {
          e.target.style.transform = "scale(1)";
          e.target.style.boxShadow = isMobile ? "0 2px 4px rgba(0, 0, 0, 0.2)" : "0 4px 8px rgba(0, 0, 0, 0.2)";
        }}
        style={{
          position: "fixed",
          bottom: isMobile ? "15px" : "20px",
          right: isMobile ? "15px" : "20px",
          background: "#25d366",
          color: "white",
          width: isMobile ? "50px" : "60px",
          height: isMobile ? "50px" : "60px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          zIndex: 9999,
          animation: "bounce 2s infinite",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
        title="Chat with us on WhatsApp"
      >
        <WhatsAppOutlined style={{ fontSize: isMobile ? "24px" : "28px" }} />
      </div>

      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-10px);
            }
            60% {
              transform: translateY(-5px);
            }
          }
          
          @media (max-width: 640px) {
            @keyframes bounce {
              0%, 20%, 50%, 80%, 100% {
                transform: translateY(0);
              }
              40% {
                transform: translateY(-8px);
              }
              60% {
                transform: translateY(-4px);
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default FloatingWhatsApp;
